<template>
  <div>
    <swiper class="swiper" :options="swiperOptions">
      <swiper-slide v-for="(i, index) in allBanners" :key="index">
        <div class="relative h-450px sm-h-600px">
          <div class="w-full">
            <img
              v-if="i.image"
              :src="`${$imageURL}/${i.image}`"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
            <img
              v-else
              src="https://nimbus-server-01.brained.in/nimbus-server-01/default/images/default2.jpg"
              alt="Banner"
              class="w-full h-450px sm-h-600px object-cover filter-b5 bg-ddd9d8"
            />
          </div>
          <div
            class="absolute sm-wfull w-full top-0 left-0 h-450px sm-h-600px lg:px-0 md:px-0 px-4 flex items-center"
          >
            <div
              class="w-60 md-w-70 sm-wfull mx-auto flex flex-col justify-center items-center"
            >
              <p
                class="sm-fsize14 font-semibold clr-fff lg:mb-5 md:mb-4 mb-3 dynamicStyle text-center cust-textColor"
              >
                {{ i.subHeading ? i.subHeading : "" }}
              </p>
              <h2
                class="fsize40 md-fsize30 sm-fsize18 font-semibold lg:mb-4 md:mb-4 mb-2 clr-fff text-center"
              >
                {{ i.heading ? i.heading : "" }}
              </h2>

              <p
                class="fsize20 md:text-lg sm-fsize14 clr-fff text-center lg:pb-10 md:pb-10 pb-4 px-6"
              >
                {{ i.content ? i.content : "" }}
              </p>

              <a
                :href="'https://' + i.link"
                target="_blank"
                class="js-anchor-link"
              >
                <button
                  v-if="i.btnName"
                  class="rounded-full py-2 px-4 bg4F0A4B clr-fff sm-fsize14"
                >
                  <!-- @click="handleScroll(i.ctaRoute)" -->
                  <!-- v-smooth-scroll="{ duration: 1000, offset: -10 }" -->

                  {{ i.btnName ? i.btnName : "" }}
                </button>
              </a>
            </div>
          </div>
        </div>
      </swiper-slide>
      <div class="swiper-button-prev adminswiper" slot="button-prev"></div>
      <div class="swiper-button-next adminswiper" slot="button-next"></div>
    </swiper>
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";
import { mapState } from "vuex";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      allBanners: [],
      imgUrl: "",
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
        },
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  methods: {
    handleScroll(URL) {
      // const el = document.getElementById("corporateForm");
      // el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (URL.includes("http")) {
        return URL;
      } else {
        return "https://" + URL;
      }
    },
  },
  computed: {
    ...mapState("campaignPageBanner", { getAllBanner: "GET_ALL" }),
    // imgUrl() {
    //   return this.ffc_banner.result[0].image;
    // },
  },
  async mounted() {
    const campID = this.$route.params;
    // console.log(campID.id);

    try {
      let payload = {
        selectedCampaigns: campID.id,
      };

      let { data } = await this.$store.dispatch(
        "campaignPageBanner/getAll",
        payload
      );
      this.allBanners = data.result || [];
    } catch (error) {
      console.error("Error in mounted lifecycle hook:", error.message);
      this.allBanners = [];
    }
  },
};
</script>
<style>
.h-450px {
  height: 450px !important;
}
.w-60 {
  width: 60%;
}
@media (max-width: 820px) and (min-width: 641px) {
  .md-w-70 {
    width: 70%;
  }
}
@media (max-width: 640px) {
  .sm-h-600px {
    height: 280px !important;
  }
  .sm-wfull {
    width: 100% !important;
  }
}
.hero-header {
  @media (max-width: 640px) {
    font-size: 24px !important;
    line-height: 32px !important;
    font-weight: 600 !important;
  }
}
.bg-ddd9d8 {
  background-color: #ddd9d8;
}
.clr-fff {
  color: #ffffff !important;
}
.bg-4f0a4b {
  background: #4f0a4b;
}
.adminswiper.swiper-button-next,
.swiper-button-prev {
  height: 27px !important;
}
</style>
